import { render } from "./Inspection.vue?vue&type=template&id=3410a4f2"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__